import * as React from "react";
import { Skeleton } from "@material-ui/lab";

export default function SearchDiamondSkeleton() {
  return (
    <>
      {/* ===== Header ===== */}
      <div className="row m-0 mb-5 p-4">
        <div className="col-6">
          <Skeleton variant="text" width={260} height={28} />
        </div>
        <div className="col-6 d-flex justify-content-end">
          <Skeleton variant="rect" style={{borderRadius:5}} width={240} height={36} />
        </div>
      </div>

      {/* BASIC BAR */}
      <div className="row mb-5">
        <div className="col-12">
          <Skeleton variant="rect" style={{borderRadius:5}} height={44} />
        </div>
      </div>

      {/* SHAPE */}
      <div className="row mb-7">
        <div className="col-md-2"><Skeleton variant="text" width={80} /></div>
        <div className="col-md-10 d-flex flex-wrap">
          {Array.from({ length: 14 }).map((_, i) => (
            <Skeleton key={i} variant="rect" width={70} style={{borderRadius:5}} height={60} className="mr-2 mb-2"/>
          ))}
        </div>
      </div>

      {/* CARAT */}
      <div className="row mb-7">
        <div className="col-md-2"><Skeleton variant="text" width={80} /></div>
        <div className="col-md-10 d-flex">
          <Skeleton variant="rect" width={160}  style={{borderRadius:25}} height={40} className="mr-3"/>
          <Skeleton variant="rect" width={160}  style={{borderRadius:25}} height={40}/>
        </div>
      </div>

      {/* COLOR */}
      <div className="row mb-7">
        <div className="col-md-2"><Skeleton variant="text" width={80} /></div>
        <div className="col-md-10 d-flex flex-wrap">
          {Array.from({ length: 18 }).map((_, i) => (
            <Skeleton key={i} variant="rect"  style={{borderRadius:5}} width={46} height={36} className="mr-2 mb-2"/>
          ))}
        </div>
      </div>

      {/* CLARITY */}
      <div className="row mb-7">
        <div className="col-md-2"><Skeleton variant="text" width={80} /></div>
        <div className="col-md-10 d-flex flex-wrap">
          {Array.from({ length: 12 }).map((_, i) => (
            <Skeleton key={i} variant="rect"  style={{borderRadius:5}} width={54} height={36} className="mr-2 mb-2"/>
          ))}
        </div>
      </div>

      {/* LAB */}
      <div className="row mb-7">
        <div className="col-md-2"><Skeleton variant="text" width={80} /></div>
        <div className="col-md-10 d-flex flex-wrap">
          <Skeleton variant="rect" width={90} style={{borderRadius:5}} height={36} className="mr-2"/>
          <Skeleton variant="rect" width={90} style={{borderRadius:5}} height={36}/>
        </div>
      </div>

      {/* SHORTCUT */}
      <div className="row mb-7">
        <div className="col-md-2"><Skeleton variant="text" width={100} /></div>
        <div className="col-md-10 d-flex flex-wrap">
          {Array.from({ length: 4 }).map((_, i) => (
            <Skeleton key={i} variant="rect" width={180} style={{borderRadius:5}} height={42} className="mr-3 mb-2"/>
          ))}
        </div>
      </div>

      {/* FINISH – 3 columns */}
      {["CUT","POLISH","SYMMETRY"].map((_, idx) => (
        <div className="row mb-7" key={idx}>
          <div className="col-md-2"><Skeleton variant="text" width={80}/></div>
          <div className="col-md-10 d-flex flex-wrap">
            {Array.from({ length: 6 }).map((_, i) => (
              <Skeleton key={i} variant="rect" style={{borderRadius:5}} width={54} height={36} className="mr-2 mb-2"/>
            ))}
          </div>
        </div>
      ))}

      {/* FLUORESCENCE */}
      <div className="row mb-7">
        <div className="col-md-2"><Skeleton variant="text" width={160}/></div>
        <div className="col-md-10 d-flex flex-wrap">
          {Array.from({ length: 7 }).map((_, i) => (
            <Skeleton key={i} variant="rect" style={{borderRadius:5}} width={120} height={40} className="mr-2 mb-2"/>
          ))}
        </div>
      </div>

      {/* LOCATION */}
      <div className="row mb-7">
        <div className="col-md-2"><Skeleton variant="text" width={100}/></div>
        <div className="col-md-10">
          <Skeleton variant="rect" style={{borderRadius:5}} width={320} height={40}/>
        </div>
      </div>

      {/* ADVANCED / PARAMETER / ADDITIONAL */}
      {Array.from({ length: 3 }).map((_, i) => (
        <div className="row mb-8" key={i}>
          <div className="col-12">
            <Skeleton variant="rect" style={{borderRadius:5}} height={44}/>
          </div>
        </div>
      ))}

      {/* Bottom buttons */}
      <div className="row pt-5 sticky-top"  style={{ bottom: "0",backgroundColor:"#f4f6fc" }}>
        <div className="col-12 d-flex justify-content-end text-right">
          <Skeleton variant="text" style={{borderRadius:5}} width={80} className="mr-4"/>
          <Skeleton variant="rect" style={{borderRadius:5}} width={150} height={40}/>
        </div>
      </div>
    </>
  );
}
